import {
    Stack,
    Typography,
    FormControlLabel,
    Switch,
    Button,
} from "@mui/material";

export default function AppearanceSettings() {
    return (
        <>
            <Typography
                sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    mb: 0.5,
                }}
            >
                Appearance
            </Typography>

            <Typography sx={{ color: "#777", mb: 4 }}>
                Customize your interface
            </Typography>

            <Stack spacing={3}>
                <FormControlLabel
                    control={<Switch />}
                    label="Dark Mode"
                />

                <FormControlLabel
                    control={<Switch />}
                    label="Compact Table Mode"
                />

                <Button
                    variant="contained"
                    sx={{
                        width: "fit-content",
                        backgroundColor: "#111",
                        borderRadius: 3,
                        textTransform: "none",
                    }}
                >
                    Save Changes
                </Button>
            </Stack>
        </>
    );
}